﻿const axios = require('axios');
import Swal from 'sweetalert2/dist/sweetalert2.js';
import { storeWishlistItem, removeWishlistItem, showTooltip } from '../project/favourites';
// General mixin for shared functionality among Vue instances
const mixin = {
    methods: {
        // Simple capitalize function.
        capitalize(value) {
            if (!value) return '';
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        },
        // Simple whitespace strip function.
        strip(value) {
            if (!value) return '';
            value = value.toString();
            return value.replace(/\s/g, '');
        },
        // Simple date object handler.
        toDateObj(dateString) {
            return new Date(dateString);
        },
        toShortDayStr(dateString, culture) {
            return new Date(dateString).toLocaleDateString(culture, { weekday: 'short' });
        },
        // Simple date string handler.
        toDateStr(dateString, culture) {
            return new Date(dateString).toLocaleDateString(culture, { day: 'numeric', month: 'short'});
        },
        toFullDateStr(dateString, culture) {
            return new Date(dateString).toLocaleDateString(culture, { day: 'numeric', month: 'short', year: 'numeric' });
        },
        toTimeStr(dateString, culture) {
            return new Date(dateString).toLocaleTimeString(culture, {hour: '2-digit', minute: '2-digit'})
        },
        toDateTime(dateString, culture) {
            return new Date(dateString).toLocaleDateString(culture, {
                year: 'numeric',
                month: 'short',
                day: 'numeric'
             }).toLowerCase() + ' | '  +
                new Date(dateString).toLocaleTimeString(culture, { 
                hour: 'numeric',
                minute: 'numeric'
            })
        },
        // Simple array reverser.
        reverse(array) {
            return [...array].reverse();
        },
        toDutchCurrency(number) {
            return new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' }).format(number).replace(',00',',-');
        },
        // General debounce function for reducing unnecessary API calls.
        debounce(cb, delay = 500) {
            let timeout;
            return (...args) => {
            clearTimeout(timeout)
            timeout = setTimeout(() => {
                cb(...args)
            }, delay)}
        },
        addWishlistItem(e) {
            let obj = e.currentTarget;
            if (obj.classList.contains('is-active')) {
                Swal.fire({
                    scrollbarPadding: false,
                    title: wishlistRemoveConfirm,
                    html: wishlistRemoveTxt1 + ' <b>' + obj.dataset.productiontitle + '</b> - <i>' + obj.dataset.productionsubtitle + '</i> ' + wishlistRemoveTxt2,
                    icon: 'warning',
                    showCancelButton: true,
                    cancelButtonText: wishListCancel,
                    confirmButtonText: wishlistRemoveTxt1
                }).then((result) => {
                    if (result.isConfirmed) {
                        removeWishlistItem(obj.dataset.eventid);
                    }
                });
            } else {
                storeWishlistItem(obj);
            }
        },
        removeFromWishlist(id, title, subtitle) {
            Swal.fire({
                scrollbarPadding: false,
                title: wishlistRemoveConfirm,
                html: wishlistRemoveTxt1 + ' <b>' + title + '</b> <i>' + subtitle + '</i> ' + wishlistRemoveTxt2,
                icon: 'warning',
                showCancelButton: true,
                cancelButtonText: wishListCancel,
                confirmButtonText: wishlistRemoveTxt1
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$emit('removeFavorite', id);
                }
            });
        },
        async fetchApiData(url, data, methodType) {
            try {
                const response = await axios({
                    method: methodType,
                    url: url,
                    data: data,
                    headers: { "Content-Type": "application/json" },
                })
                return response;
            } catch (error) {
                console.log(error);
            }
        }
    }
}

export default mixin;
